import { render, staticRenderFns } from "./DocumentReleaseOfInformation.vue?vue&type=template&id=2a9f8862&"
import script from "./DocumentReleaseOfInformation.vue?vue&type=script&lang=js&"
export * from "./DocumentReleaseOfInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports